import type { Template } from "@/types";

export const LA_07_H5_V2: Template[] = [
    {
        id: "la-07-h5v2-01",
        name: "LA 01 - H5V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h5_v2_01.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 96, y: 53, width: 205, height: 140, rotation: 0, imageRotation: 0 },
            { id: "2", x: 96, y: 201, width: 205, height: 140, rotation: 0, imageRotation: 0 },
            { id: "3", x: 96, y: 349, width: 205, height: 140, rotation: 0, imageRotation: 0 },
            { id: "4", x: 309, y: 53, width: 272, height: 437, rotation: 0, imageRotation: 0 },
            { id: "5", x: 761, y: 88, width: 249, height: 179, rotation: 0, imageRotation: 0 },
            { id: "6", x: 761, y: 275, width: 249, height: 179, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1018, y: 88, width: 250, height: 366, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "la-07-h5v2-02",
        name: "LA 02 - H5V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h5_v2_02.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 94, y: 45, width: 276, height: 451, rotation: 0, imageRotation: 0 },
            { id: "2", x: 378, y: 45, width: 205, height: 144, rotation: 0, imageRotation: 0 },
            { id: "3", x: 378, y: 197, width: 205, height: 299, rotation: 0, imageRotation: 0 },
            { id: "4", x: 756, y: 46, width: 516, height: 313, rotation: 0, imageRotation: 0 },
            { id: "5", x: 756, y: 367, width: 167, height: 128, rotation: 0, imageRotation: 0 },
            { id: "6", x: 931, y: 367, width: 167, height: 128, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1106, y: 367, width: 166, height: 128, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h5v2-03",
        name: "LA 03 - H5V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h5_v2_03.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 127, y: 53, width: 416, height: 222, rotation: 0, imageRotation: 0 },
            { id: "2", x: 127, y: 283, width: 269, height: 205, rotation: 0, imageRotation: 0 },
            { id: "3", x: 404, y: 283, width: 139, height: 205, rotation: 0, imageRotation: 0 },
            { id: "4", x: 771, y: 53, width: 272, height: 437, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1051, y: 53, width: 205, height: 141, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1051, y: 202, width: 205, height: 140, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1051, y: 350, width: 205, height: 140, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h5v2-04",
        name: "LA 04 - H5V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h5_v2_04.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 163, y: 63, width: 190, height: 134, rotation: 0, imageRotation: 0 },
            { id: "2", x: 163, y: 205, width: 190, height: 134, rotation: 0, imageRotation: 0 },
            { id: "3", x: 163, y: 347, width: 190, height: 133, rotation: 0, imageRotation: 0 },
            { id: "4", x: 361, y: 63, width: 263, height: 417, rotation: 0, imageRotation: 0 },
            { id: "5", x: 632, y: 63, width: 264, height: 417, rotation: 0, imageRotation: 0 },
            { id: "6", x: 904, y: 63, width: 286, height: 205, rotation: 0, imageRotation: 0 },
            { id: "7", x: 904, y: 276, width: 286, height: 204, rotation: 0, imageRotation: 0 } 
        ],
    },

    {
        id: "la-07-h5v2-05",
        name: "LA 05 - H5V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h5_v2_05.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 163, y: 63, width: 190, height: 134, rotation: 0, imageRotation: 0 },
            { id: "2", x: 163, y: 205, width: 190, height: 134, rotation: 0, imageRotation: 0 },
            { id: "3", x: 163, y: 347, width: 190, height: 133, rotation: 0, imageRotation: 0 },
            { id: "4", x: 361, y: 63, width: 263, height: 417, rotation: 0, imageRotation: 0 },
            { id: "5", x: 632, y: 63, width: 286, height: 205, rotation: 0, imageRotation: 0 },
            { id: "6", x: 632, y: 276, width: 286, height: 204, rotation: 0, imageRotation: 0 },
            { id: "7", x: 926, y: 63, width: 264, height: 417, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "la-07-h5v2-06",
        name: "LA 06 - H5V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h5_v2_06.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 28, y: 63, width: 575, height: 417, rotation: 0, imageRotation: 0 },
            { id: "2", x: 611, y: 63, width: 131, height: 205, rotation: 0, imageRotation: 0 },
            { id: "3", x: 611, y: 276, width: 284, height: 204, rotation: 0, imageRotation: 0 },
            { id: "4", x: 750, y: 63, width: 284, height: 205, rotation: 0, imageRotation: 0 },
            { id: "5", x: 903, y: 276, width: 284, height: 204, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1042, y: 63, width: 284, height: 205, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1195, y: 276, width: 131, height: 204, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "la-07-h5v2-07",
        name: "LA 07 - H5V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h5_v2_07.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 28, y: 63, width: 575, height: 417, rotation: 0, imageRotation: 0 },
            { id: "2", x: 611, y: 63, width: 131, height: 205, rotation: 0, imageRotation: 0 },
            { id: "3", x: 611, y: 276, width: 131, height: 204, rotation: 0, imageRotation: 0 },
            { id: "4", x: 750, y: 63, width: 284, height: 205, rotation: 0, imageRotation: 0 },
            { id: "5", x: 750, y: 276, width: 284, height: 204, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1042, y: 63, width: 284, height: 205, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1042, y: 276, width: 284, height: 204, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h5v2-08",
        name: "LA 08 - H5V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h5_v2_08.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 28, y: 63, width: 575, height: 417, rotation: 0, imageRotation: 0 },
            { id: "2", x: 611, y: 63, width: 284, height: 205, rotation: 0, imageRotation: 0 },
            { id: "3", x: 611, y: 276, width: 284, height: 204, rotation: 0, imageRotation: 0 },
            { id: "4", x: 903, y: 63, width: 283, height: 205, rotation: 0, imageRotation: 0 },
            { id: "5", x: 903, y: 276, width: 283, height: 204, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1194, y: 63, width: 132, height: 205, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1194, y: 276, width: 132, height: 204, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h5v2-09",
        name: "LA 09 - H5V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h5_v2_09.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 61, y: 70, width: 333, height: 228, rotation: 0, imageRotation: 0 },
            { id: "2", x: 61, y: 306, width: 219, height: 167, rotation: 0, imageRotation: 0 },
            { id: "3", x: 288, y: 306, width: 220, height: 167, rotation: 0, imageRotation: 0 },
            { id: "4", x: 402, y: 70, width: 334, height: 228, rotation: 0, imageRotation: 0 },
            { id: "5", x: 516, y: 306, width: 220, height: 167, rotation: 0, imageRotation: 0 },
            { id: "6", x: 744, y: 70, width: 269, height: 403, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1021, y: 70, width: 270, height: 403, rotation: 0, imageRotation: 0 },
                   
        ],
    },

    {
        id: "la-07-h5v2-10",
        name: "LA 10 - H5V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h5_v2_10.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 61, y: 68, width: 270, height: 403, rotation: 0, imageRotation: 0 },
            { id: "2", x: 339, y: 68, width: 269, height: 403, rotation: 0, imageRotation: 0 },
            { id: "3", x: 616, y: 243, width: 334, height: 228, rotation: 0, imageRotation: 0 },
            { id: "4", x: 958, y: 243, width: 333, height: 228, rotation: 0, imageRotation: 0 },
            { id: "5", x: 616, y: 68, width: 220, height: 167, rotation: 0, imageRotation: 0 },
            { id: "6", x: 844, y: 68, width: 220, height: 167, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1072, y: 68, width: 219, height: 167, rotation: 0, imageRotation: 0 }
        ],
    }
];